module.exports = __webpack_public_path__ + "static/media/glow.3b6b0c75.png";